export default "__VITE_ASSET__CZLoKwPC__"